import React, { useState, useEffect } from "react";

import FooterLogo from "./FooterLogo";

const DefaultFooterLogo = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    global.deviceWidth > 876 && setIsDesktop(!isDesktop);
  }, []);

  const width = isDesktop ? "200" : "180";
  const height = isDesktop ? "27" : "24.3";

  return <FooterLogo width={width} height={height} />;
};

export default DefaultFooterLogo;
